import { useSelector } from 'react-redux';
import { useMemo, useEffect } from 'react';
import { prop, path } from 'js/utils/ramda.util';
import { PAGE_IN_POPUP_REDUCER } from 'js/store/constants';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import { useIsPageInPopupUrl } from 'js/components/system/Page/hooks';
import { useAppSelector, useUserSelector, usePageSelector } from 'js/store/hooks';

import { languageService } from 'js/services/language.service';
import { setCurrentLanguage, deletePathLanguage } from './helpers';

export const useSetCurrentLanguage = () => {
    const history = useHistory();
    const location = useLocation();
    const isPageInPopupUrl = useIsPageInPopupUrl();
    const currentLang = useUserSelector(prop('lang'));
    const pageUrl = usePageSelector(prop('url'));
    const defaultLang = useAppSelector(prop('defaultLocale'));
    const pageInPopupUrl = useSelector(path([PAGE_IN_POPUP_REDUCER, 'url']));

    return useMemo(() => {
        const url = isPageInPopupUrl() ? pageInPopupUrl : pageUrl;

        return {
            setCurrentLanguage: langToSet => setCurrentLanguage({ langToSet, currentLang, defaultLang, history, location, url })
        };
    }, [location, currentLang, history, pageUrl, pageInPopupUrl, defaultLang, isPageInPopupUrl]);
};

export const useNormalizeUrl = () => {
    const history = useHistory();
    const location = useLocation();
    const { pathLang } = useParams();
    const currentLang = useUserSelector(prop('lang'));
    const defaultLanguage = useAppSelector(prop('defaultLocale'));

    useEffect(() => {
        if (!defaultLanguage) {
            return;
        }

        if (!pathLang && currentLang && currentLang !== defaultLanguage) {
            setCurrentLanguage({ langToSet: currentLang, currentLang: null, history, location });
        }

        if (currentLang === defaultLanguage && languageService.getLanguage(pathLang) === defaultLanguage) {
            deletePathLanguage({ history, location });
        }
    }, [defaultLanguage, pathLang, history, location, currentLang]);
};
